export const ROOT = '/OnboardingAPI';
export const DETAILS = `${ROOT}/getonboarding`;
export const LIST = `${ROOT}/getonboardinglist`;
export const TRAINING = `${ROOT}/trainingnameddl`;
export const PARTICIPANT = `${ROOT}/Participants`;
export const TRAINEE = `${ROOT}/trainee`;
export const ATTENDANCE = `${ROOT}/attendance`;
export const GET_HOLIDAY_DATES = `${ROOT}/getholidaydates`;
export const EXPORT_ONBOARDING_LIST = `${ROOT}/exportoblist`;
export const EXPORT_ATTENDANCE = `${ROOT}/exportobparticipants`;
